import * as React from 'react';
import {Component} from 'react';
import {validNumber} from '../utils/validation';

interface Props {
    value: string;
    onUpdate?(value: string): void;
    onChange(value: string): void;
    render(props: InjectedDurationProps): JSX.Element;
    disabled?: boolean;
}

interface State {
    value: string;
}

export interface InjectedDurationProps extends State {
    placeholder: string;
    handleChange(value: string): void;
    handleEndEditing(duration: string);
}

function isValid(value: string): boolean {
    if (value === 'N' || value === 'NUL') {
        return true;
    }
    // check valid carachters
    if (!value.match(/[0-9:?]*/)) {
        return false;
    }
    if (value.split(':').length === 1) {
        const [hours] = value.split(':');
        return validNumber(hours, 999);
    }

    if (value.split(':').length === 2) {
        /** check fo only XXX:XX format*/

        let valid = true;
        const [hours, minutes] = value.split(':');
        if (hours) {
            valid = validNumber(hours, 999);
        }
        if (minutes) {
            valid = minutes.length <= 2 && validNumber(minutes[0], 5) && validNumber(minutes, 59);
        }
        return valid;
    }
    if (value.split(':').length > 2) {
        return false;
    }

    // // check ':' place
    // if(value.indexOf(':') > 3 || value.indexOf(':') === 0) {
    //   return false;
    // }

    // if(value.indexOf(':') > -1) {
    //   const [hours,minutes] = value.split(':');
    //   return hours.length <= 3 && minutes <= 60;
    // }
    // else {
    //   return value.length <= 3;
    // }
    return true;
}

export class DurationControl extends Component<Props, State> {
    static defaultProps = {
        value: ''
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleEndEditing = this.handleEndEditing.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    handleChange(value: string) {
        const {onChange} = this.props;
        // need to handle backspace
        // const duration = value.length === 3 && !value.includes(':') ? value + ':' : value;

        if (isValid(value)) {
            let newValue = value;
            const oldValue = this.state.value;
            /**
             * check if type/delete NULL
             */

            if (newValue === 'N') {
                newValue = 'NULL';
            } else if (oldValue === 'NULL' && newValue === 'NUL') {
                newValue = '';
            } else if (value.length <= 3 && value.length === value.indexOf(':') + 1) {
                /**
                 * Add zeros to the format of 000:00
                 */
                if (value.length === 2) {
                    newValue = '00' + value;
                }
                if (value.length === 3) {
                    newValue = '0' + value;
                }
            } else if (value.length === 3 && oldValue.length === 2) newValue = `${value}:`;
            else if (value.length === 3 && oldValue.length === 4) newValue = value.substring(0, 2);
            this.setState({
                value: newValue
            });
            onChange && onChange(newValue);
        }
    }

    handleEndEditing() {
        const {onUpdate} = this.props;
        const {value} = this.state;
        onUpdate(value);
    }

    render() {
        const {render: Component} = this.props;
        return (
            <Component
                {...this.props}
                {...this.state}
                placeholder="000:00"
                handleChange={this.handleChange}
                handleEndEditing={this.handleEndEditing}
            />
        );
    }
}

export const withDuration = <P extends InjectedDurationProps>(
    Component: React.ComponentType<P>
) => {
    return props => {
        return <DurationControl {...props} render={p => <Component {...(p as P)} />} />;
    };
};
